import TextField, { TextFieldProps } from '@mui/material/TextField';
import React from 'react';
import { IValidation } from './utils';

export interface IContentBaseField {
  touched: boolean;
  validation: IValidation;
  name: string;
}

export default function ContentBaseField(props: IContentBaseField & TextFieldProps) {
  const {touched, validation, name, helperText} = props;
  return (
    <TextField
      {...props}
      error={(!touched && validation.hasOwnProperty(name)) || props.error}
      helperText={!touched && validation.hasOwnProperty(name) ? [validation[name], helperText].join('. ') : helperText}
    />
  )
}
